export default __webpack_public_path__ + "static/whs_logo-bb4399cec5dbe81756e5da48f9582750.png";